import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserProfile } from "../../../user-profile/user-profile.thunks";
import store, { waitForCart, waitForUser } from "../../../../store/store";
import { StoreState } from "../../../../store/store.interface";
import { getCustomerToken } from "../../../customer/customer";
import { isHeStudent, isSegIndividualStudent, isSuccessUser } from "../../../user-profile/user-profile.selectors";
import { initializeLoggedInCartMagentoApiCall } from "../api/initialize-cart.api";
import { InitializeCartRequest, CartResponse, InitializeCartResponse } from "../interface/initialize-cart.interface";
import { ShopCart } from "../../shop-cart/interfaces/shop-cart.interface";
import { getCartItemMagento } from "../../shop-cart/thunks/shop-cart-commons";

export const initializeCart = createAsyncThunk('shopCart/initializeCart', async (initializeCartRequest: InitializeCartRequest, thunkAPI) => {
  try {
    thunkAPI.dispatch(fetchUserProfile());
    await waitForUser();
    let response: InitializeCartResponse | undefined = undefined;
    const state = store.getState() as StoreState;
    let cart: ShopCart | undefined = undefined;

    if (!isSuccessUser(state)) {
      throw new Error('User is not logged in.');
    }

    // only HE & SEG_INDIVIDUAL STUDENT role users are allowed to make the initialize-cart request.
    // so checking the logged-in user role before making the API call
    if (!isHeStudent(state) && !isSegIndividualStudent(state)) {
      throw new Error('User must be either a HE student or SEGINDIVIDUAL Student.');
    }

    const stateForMagento = thunkAPI.getState() as StoreState;
    response = await initializeMagentoCart(initializeCartRequest, stateForMagento);
    cart = await getCartItemMagento(stateForMagento);
    return { ...cart, addToCartResponse: response } as unknown as CartResponse;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}, {
  condition: (async (_arg) => {
    await waitForCart();
    return true;
  })
});

async function initializeMagentoCart(
  initializeCartRequest: InitializeCartRequest,
  state: StoreState
) {
  const customerToken = getCustomerToken(state);

  return await initializeLoggedInCartMagentoApiCall(
    initializeCartRequest,
    customerToken,
  );
}
